import {errorActions} from "../ErrorHandler/errorHandler";
import api from "../../util/api";

export const actionTypes = {
    getAllMediaItems: "getAllMediaItems",
    setMediaDataLoading: "setMediaDataLoading",
};

const initialMediaItemsListState = {
    allMediaItems: [],
    mediaItemsListError: {},
    isLoadingMediaItemsList: true,
};

export const mediaItemsListReducer = (state = initialMediaItemsListState, action) => {
    switch (action.type) {
        case actionTypes.getAllMediaItems: {
            const {allMediaItems, mediaItemsListError} = action.payload;
            return {
                ...state,
                allMediaItems,
                mediaItemsListError,
            };
        }

        case actionTypes.setMediaDataLoading: {
            const {isLoadingMediaItemsList} = action.payload;

            return {
                ...state,
                isLoadingMediaItemsList,
            };
        }

        default:
            return state;
    }
};

const setMediaLoading = isLoadingMediaItemsList => ({
    type: actionTypes.setMediaDataLoading,
    payload: {isLoadingMediaItemsList},
});

export const mediaItemsListActions = {
    getAllMediaItems: () => dispatch => {
        dispatch(setMediaLoading(true));
        return api
            .get(`v2/api/settings/videos`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
            })
            .then(({data: {data = [], message = [{}]}}) => {
                dispatch(setMediaLoading(false));

                dispatch({
                    type: actionTypes.getAllMediaItems,
                    payload: {
                        allMediaItems: data,
                        mediaItemsListError: message[0],
                    },
                });
            })
            .catch(err => {
                console.error(err);
                dispatch(setMediaLoading(false));
                dispatch(errorActions.setErrorMessage(err.message));
            });
    },

    setLoader: bool => dispatch => {
        dispatch(setMediaLoading(bool));
    },
};
